var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlinedCreateBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 48,
    viewBox: "0 0 63 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M45.4 4H32.6C29.2397 4 27.5595 4 26.2761 4.65396C25.1471 5.2292 24.2292 6.14708 23.654 7.27606C23 8.55953 23 10.2397 23 13.6V34.4C23 37.7603 23 39.4405 23.654 40.7239C24.2292 41.8529 25.1471 42.7708 26.2761 43.346C27.5595 44 29.2396 44 32.5999 44H39L55 21V13.6C55 10.2397 55 8.55953 54.346 7.27606C53.7708 6.14708 52.8529 5.2292 51.7239 4.65396C50.4405 4 48.7603 4 45.4 4Z",
    fill: "#3D1CAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21V13.6C55 10.2397 55 8.55953 54.346 7.27606C53.7708 6.14708 52.8529 5.2292 51.7239 4.65396C50.4405 4 48.7603 4 45.4 4H32.6C29.2397 4 27.5595 4 26.2761 4.65396C25.1471 5.2292 24.2292 6.14708 23.654 7.27606C23 8.55953 23 10.2397 23 13.6V34.4C23 37.7603 23 39.4405 23.654 40.7239C24.2292 41.8529 25.1471 42.7708 26.2761 43.346C27.5595 44 29.2397 44 32.6 44H39M51 42V30M45 36H57",
    stroke: "#3D1CAF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 13,
    height: 19,
    rx: 4,
    stroke: "#B1A4DF",
    strokeWidth: 3.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedCreateBoard);
export default __webpack_public_path__ + "static/media/OutlinedCreateBoard.0d110e95ceca730ff006e514f6fee95f.svg";
export { ForwardRef as ReactComponent };